import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import {
  Button,
  Box,
  Typography,
  TextField,
  Checkbox,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AIJobCreationIcon from "../../Assets/CustomIcons/AIJobCreationIcon";
import axios from "axios";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiButton-root": {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      minWidth: 120,
    },
    "& .MuiDialogActions-root": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(2),
    },
  },
}));

export default function ExternalJobIDDialog({
  open,
  onClose,
  onConfirm,
  defaultExternalJobID = "",
}) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [externalJobID, setExternalJobID] = useState("");
  const [isOpenSalary, setIsOpenSalary] = useState(false);
  const [existingJobs, setExistingJobs] = useState([]);
  const [isChecking, setIsChecking] = useState(false);
  const isPrefilled = !!defaultExternalJobID;
  const handleConfirm = () => {
    if (!externalJobID.trim()) return;

    onConfirm({
      externalJobID,
      isOpenSalary,
    });
  };

  const isFormValid = () => {
    if (!externalJobID.trim()) return false;
    return true;
  };

  useEffect(() => {
    if (defaultExternalJobID) {
      setExternalJobID(defaultExternalJobID.toString());
    }
  }, [defaultExternalJobID]);

  useEffect(() => {
    if (!externalJobID.trim()) {
      setExistingJobs([]);
      return;
    }

    const delayDebounce = setTimeout(async () => {
      try {
        setIsChecking(true);

        const response = await axios.get(
          "/wp-json/api/v2/getOpenJobsByExternalID",
          {
            params: {
              externalID: externalJobID, // IMPORTANT: match PHP
            },
          },
        );

        if (response.data && Array.isArray(response.data)) {
          setExistingJobs(response.data);
        } else {
          setExistingJobs([]);
        }
      } catch (err) {
        console.error("Error checking external job ID", err);
        setExistingJobs([]);
      } finally {
        setIsChecking(false);
      }
    }, 600); // debounce

    return () => clearTimeout(delayDebounce);
  }, [externalJobID]);

  useEffect(() => {
    if (!open) return;

    if (defaultExternalJobID) {
      setExternalJobID(defaultExternalJobID.toString());
    } else {
      setExternalJobID("");
    }

    setIsOpenSalary(false);
    setExistingJobs([]);
  }, [open, defaultExternalJobID]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.root}
    >
      <Box
        py={theme.spacing(2)}
        justifyContent="center"
        display="flex"
        alignItems="center"
      >
        <AIJobCreationIcon fontSize="80" />
      </Box>
      <Box justifyContent="center" display="flex" alignItems="center">
        <Typography variant="h5" color="textPrimary" gutterBottom={true}>
          {`פתיחת משרה באמצעות AI`}
        </Typography>
      </Box>

      <DialogContent>
        <Box>
          <React.Fragment>
            <Typography variant="body1" color="textSecondary">
              נא להזין את מספר המשרה כפי שהוא מופיע במערכת "אדם". על בסיס מספר
              זה נייבא את נתוני הדרישות ונייצר משרה חדשה במערכת ליבי באמצעות AI.
            </Typography>
            <Box mt={2}>
              <TextField
                id="externalJobID"
                label="מספר משרה באדם"
                type="number"
                fullWidth
                variant="filled"
                value={externalJobID}
                onChange={(e) => setExternalJobID(e.target.value)}
                InputProps={{
                  readOnly: isPrefilled,
                }}
              />
            </Box>
            {existingJobs.length > 0 && (
              <Box mt={2}>
                <Alert severity="warning">
                  <Typography variant="body2">
                    נמצאו משרות שכבר נוצרו עם מזהה זה:
                  </Typography>

                  <Box mt={1}>
                    {existingJobs.map((jobId) => (
                      <Box key={jobId}>
                        <Link to={`/jobs/dashboard/${jobId}`}>
                          משרה {jobId}#
                        </Link>
                      </Box>
                    ))}
                  </Box>
                </Alert>
              </Box>
            )}
            <Box mt={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isOpenSalary}
                    onChange={(e) => setIsOpenSalary(e.target.checked)}
                    color="primary"
                  />
                }
                label="שאלת שכר פתוחה"
              />
            </Box>
          </React.Fragment>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleConfirm}
          color="primary"
          disabled={!isFormValid()}
        >
          אישור
        </Button>
        <Button variant="outlined" onClick={onClose} color="primary">
          ביטול פעולה
        </Button>
      </DialogActions>
    </Dialog>
  );
}
